// External dependencies
import { filter, switchMap } from 'rxjs/operators';

// Local dependencies
import { getClient } from '../../../../../clients/client';
import { User } from '../../types';
import { getUserError, getUserSuccess } from './action';
import { getUserQuery } from './queries';
import { GetUser, GetUserAction, GetUserActionTypes } from './types';

export default function getUserEpic(action$) {
  return action$.pipe(
    filter((action: GetUserAction) => action.type === GetUserActionTypes.GET_USER_REQUEST),
    switchMap((action: GetUser) =>
      getUser(action)
        .then(getUserSuccess)
        .catch((error: Error) => getUserError(error)),
    ),
  );
}

export async function getUser(action): Promise<User> {
  const { userId } = action;

  const graphQLClient = await getClient();

  const {
    data: { getUser },
  } = await graphQLClient.query({
    query: getUserQuery,
    variables: {
      input: {
        id: userId,
      },
    },
  });

  return getUser;
}
